import { Box, Link, Typography } from '@mui/material';

import { FormattedMessage } from 'react-intl';

/** Footer section displayed at the bottom of the login panel. */
export function LoginFooter() {
  return (
    <Box component="footer" sx={{ marginTop: 'auto' }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          color: 'text.secondary',
          typography: 'body2',
        }}
      >
        <Link
          href="https://mediainbox.net/privacy-policy"
          target="_blank"
          rel="noopener noreferrer"
          color="inherit"
          underline="hover"
        >
          <FormattedMessage
            id="auth.loginScreen.privacyPolicy"
            defaultMessage="Política de privacidad"
          />
        </Link>
        <Typography component="span">·</Typography>
        <Link
          href="https://mediainbox.net/terms-of-service"
          target="_blank"
          rel="noopener noreferrer"
          color="inherit"
          underline="hover"
        >
          <FormattedMessage
            id="auth.loginScreen.termsOfService"
            defaultMessage="Términos de servicio"
          />
        </Link>
      </Box>
    </Box>
  );
}
